import React, { useEffect, useState } from "react"
import { Container, Currencies } from "@orbital/games-frontend-library"
import GambleCard from "./gambleComponents/GambleCard"
import GambleHistory from "./gambleComponents/GambleHistory"
import GambleActions from "./gambleComponents/GambleActions"
import { GAMBLE_PROPS } from "./interface"
import { Main } from "./GambleStyled"
import { GamePlayButton } from "../../footer/FooterStyled"

import { endRound } from "../../functions/gameFunctions"

export default function Gamble({
  colors,
  handleAbove,
  stateRound,
  sendSocketMessage,
  showGambleResult,
  audioUrl,
  gameInfo,
  handleNotification,
}: GAMBLE_PROPS) {
  const [anim, setAnim] = useState<boolean>(false)
  const [cashout, setCashout] = useState<boolean>(false)
  // const { volume, sound } = audio;
  const [changeCard, setChangeCard] = useState<boolean>(false)
  const { winamount, doubleupcard, history } = stateRound
  const { currency, precision, game_settings } = gameInfo

  const handleCashout = () => {
    setCashout(true)
    setAnim(true)
    endRound(sendSocketMessage)
    audioUrl.cashout()
    setTimeout(() => {
      setAnim(false)
      handleAbove(false)
    }, 167)
  }

  useEffect(() => {
    if (stateRound.state !== 7) {
      setChangeCard(true)
      setTimeout(() => {
        setChangeCard(false)
      }, 500)
    }
  }, [stateRound])

  const handleCashoutClick = (e: boolean) => {
    setCashout(e)
  }

  useEffect(() => {
    if (Number(winamount) >= Number(game_settings.maxWin)) {
      handleNotification(
        `You Have Reached  Max Win Amount of ${game_settings.maxWin +
          Currencies[
            currency
          ]}, you can't win anymore in this round so please, cash out and begin a new Round!`,
      )
    }
     // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [winamount, game_settings.maxWin, currency])
  return (
    <Container unBlur={false} backgroundColor={colors && colors.primary}>
      <Main colors={colors}>
        <GambleHistory
          colors={colors}
          gambleHistory={history}
          state={stateRound.state}
        />
        <GambleCard
          card={doubleupcard}
          colors={colors}
          changeCard={changeCard}
          winamount={winamount}
          showGambleResult={showGambleResult}
          gambleHistory={history}
        />
        <GambleActions
          showGambleResult={showGambleResult}
          sendSocketMessage={sendSocketMessage}
          stateRound={stateRound}
          setChangeCard={setChangeCard}
          card={doubleupcard}
          audioUrl={audioUrl}
          cashout={cashout}
          handleCashout={handleCashoutClick}
        />
        <GamePlayButton
          colors={colors}
          onClick={() => !cashout && handleCashout()}
          anim={anim}
          isClickable={stateRound.state === 4 && !cashout}
        >
          <p>Collect</p>
          <span>
            {winamount.toFixed(precision)} {Currencies[currency]}
          </span>
        </GamePlayButton>
      </Main>
    </Container>
  )
}
